// import React from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";

// const CarouselContainer = ({ children }) => {

//   return (

//     <div className=" w-full flex flex-col justify-center items-center md:bg-black  md:border-none md:px-48">
//       <div className="flex flex-col justify-center items-center pt-4 sm:pt-0 sm:py-8 md:py-6 w-full lg:w-10/12">
//         <Carousel
//           autoPlay
//           infiniteLoop
//           interval={3000}
//           itemsToShow={1}
//           itemsToScroll={1}
//           breakPoints={[
//             {
//               width: 1,
//               itemsToShow: 1,
//               itemsToScroll: 1,
//               showArrows: false,
//             },
//           ]}
//           className="h-auto w-screen"
//           showStatus={false}
//           showThumbs={false}
//           showIndicators={false}
//         >
//           {children}
//         </Carousel>
//       </div>
//     </div>
//   );
// };

// export default CarouselContainer;


import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
const CarouselContainer = ({ children }) => {
  // Prevent vertical scrolling from triggering carousel navigation
  const handleWheel = (e) => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.stopPropagation();
    }
  };
  return (
    <div className="w-full flex flex-col justify-center items-center md:bg-black md:border-none md:px-48">
      <div
        className="flex flex-col justify-center items-center pt-4 sm:pt-0 sm:py-8 md:py-6 w-full lg:w-10/12"
        onWheel={handleWheel}
      >
        <Carousel
          autoPlay
          infiniteLoop
          interval={3000}
          className="h-auto w-screen"
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
          swipeable={true}
          emulateTouch={true}
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={50}
        >
          {children}
        </Carousel>
      </div>
    </div>
  );
};
export default CarouselContainer;









